
// ============================================
// WHO WE ARE OurBusinessSection
// ============================================
/**
 * GNS.OurBusiness
 * 
 * WHO WE AREページ内の事業紹介セクション(#ourbusiness)の処理
 * 独立したページではなく、WHO WE AREページの一部として機能
 * 
 * 機能:
 * - 事業内容の表示
 * - 各事業カテゴリの背景画像スライドショー
 * - スクロールに応じたセクション表示
 * - 関連実績の表示
 * 
 * 主要メソッド:
 * - load(): 画像リソースの読み込み開始 (データはSSR済み)
 * - resize(): リサイズ処理
 * - scrollTo(section): 指定セクションへスクロール
 * - onscroll(): スクロールイベント処理
 */
GNS.OurBusinessScene = function (GNS) {
    // AbstractSceneを継承してインスタンスを作成
    const scene = GNS.create(GNS.AbstractScene);

    // 定数定義
    const COLUMN_MARGIN = 30; // scrollTo/onScrollで使用されていた固定値

    /**
     * 初期化処理
     */
    scene.init = function (data) {
        // 親クラスのinit呼び出し
        scene._super.init.apply(this, [data]);

        this.pageLoadCount = 0;
        this.offset = 0;

        // DOMからカラムを動的に取得
        // PHP: id="ourbusiness__overview__columnX"
        const columnElements = this.element.querySelectorAll(".ourbusiness__overview__column");

        this.pages = Array.from(columnElements).map((el) => {
            // IDが存在しない場合はスキップ（通常ありえないが念のため）
            if (!el.id) return null;
            return new GNS.OurBusinessOverviewColumn(el.id, this);
        }).filter(page => page !== null);
    };

    /**
     * ロード処理
     * PHP側でHTML生成済みのため、イベントリスナを設定して読み込み開始
     */
    scene.load = function () {
        this.pages.forEach((page) => {
            page.addEventListener(GNS.Event.LOAD, this.pageLoaded);
            page.load();
            this.addSceneEventIn(page.cases.element);
        });
    };

    /**
     * イベントハンドラ: ページ読み込み完了時
     */
    scene._bind.pageLoaded = function () {
        this.pageLoadCount++;

        // 全ページの読み込みが完了したら
        if (this.pageLoadCount >= this.pages.length) {
            this.pages.forEach((page) => {
                page.removeEventListener(GNS.Event.LOAD, this.pageLoaded);
            });
            this.loadComplete();
        }
    };

    /**
     * イベントハンドラ: 全体のロード完了処理
     */
    scene._bind.loadComplete = function () {
        GNS.SceneController.dispatcher.addEventListener("CHANGE_LANG", this.changelang);
        GNS.ResizeManager.addEventListener(this.resize);

        this.resize();
        scene._super.load.call(this);
    };

    /**
     * 言語切り替え時の処理
     */
    scene._bind.changelang = function () {
        GNS.Menu.getInstance().addEventListener("closed", this.menuClosed);
    };

    /**
     * メニューが閉じられた時の処理
     */
    scene._bind.menuClosed = function () {
        GNS.Menu.getInstance().removeEventListener("closed", this.menuClosed);
        this.resize();
    };

    /**
     * リサイズ処理
     */
    scene._bind.resize = function () {
        // 各ページのリサイズを実行
        // 元のコードにあった高さの累積計算(b += d)は、結果がどこにも使われていないため削除
        this.pages.forEach(page => page.resize());

        // 最初のページのY位置をオフセットとして保持
        if (this.pages.length > 0) {
            this.offset = GNS.DOM.getPosition(this.pages[0].element).y;
        }
    };

    /**
     * 表示ハンドラ
     */
    scene.showHandler = function () {
        GNS.DOM.addEvent(document, "scroll", this.onscroll);
    };

    /**
     * 非表示ハンドラ
     */
    scene.hideHandler = function () {
        GNS.Menu.getInstance().removeEventListener("closed", this.menuClosed);
        GNS.SceneController.dispatcher.removeEventListener("CHANGE_LANG", this.changelang);
        GNS.DOM.removeEvent(document, "scroll", this.onscroll);

        this.pages.forEach(page => page.hide());
    };

    /**
     * リセットハンドラ
     */
    scene.resetHandler = function () {
        GNS.ResizeManager.removeEventListener(this.resize);
    };

    /**
     * 特定のページ位置までスクロール
     */
    scene.scrollTo = function (targetPage) {
        const pageSize = GNS.DOM.getPageSize();
        const displayHeight = pageSize.displayHeight;
        let currentOffset = this.offset;

        for (let i = 0; i < this.pages.length; i++) {
            const page = this.pages[i];
            const pageBlockHeight = page.height + COLUMN_MARGIN;

            if (page === targetPage) {
                // 画面の1/4の位置に来るように調整
                const targetScrollTop = currentOffset - (displayHeight / 4);

                GNS.Animate.to(document, 0.5, {
                    scrollTop: targetScrollTop,
                    ease: GNS.Animate.easeInOutQuart
                });
                break;
            }
            currentOffset += pageBlockHeight;
        }
    };

    /**
     * スクロールイベントハンドラ
     * スクロール位置に応じてページを表示(show)する
     */
    scene._bind.onscroll = function () {
        const pageSize = GNS.DOM.getPageSize();
        const scrollY = pageSize.scrollY;
        const viewCenter = pageSize.displayHeight >> 1; // displayHeight / 2 と同義
        const triggerPoint = scrollY + viewCenter;

        let currentOffset = this.offset;

        for (let i = 0; i < this.pages.length; i++) {
            const page = this.pages[i];
            const pageBlockHeight = page.height + COLUMN_MARGIN;

            // トリガーポイントが現在のオフセットに達していない場合はループ終了
            if (triggerPoint < currentOffset) break;

            page.show();
            currentOffset += pageBlockHeight;
        }
    };

    return scene._self;
}(GNS);







/**
 * GNS.OurBusinessOverviewColumn
 * 事業紹介ページの各カラム制御クラス
 */
GNS.OurBusinessOverviewColumn = function (GNS) {
    // DisplayObjectを継承
    const column = GNS.create(GNS.DisplayObject);

    // アニメーション設定定数
    const ANIM = {
        SCALE_DURATION: 16,     // 画像が拡大し続ける時間
        FADE_OUT_DELAY: 9,      // フェードアウト開始までの待機時間
        FADE_OUT_DURATION: 0.6, // フェードアウトにかかる時間
        ARROW_BLINK_CYCLE: 0.6  // 矢印のアニメーションサイクル
    };

    /**
     * 初期化
     */
    column.init = function (selector, parent) {
        column._super.init.call(this, selector);

        this.parent = parent;
        this.isAnimating = false;

        // DOM要素の取得
        this.ui = {
            title: new GNS.DisplayObject(this.element.querySelector(".ourbusiness__overview__title")),
            wrapper: new GNS.DisplayObject(this.element.querySelector(".ourbusiness__overview__rap")), // 'rap' -> wrapper
            cases: new GNS.DisplayObject(this.element.querySelector(".ourbusiness__overview__cases")),
            bg: new GNS.DisplayObject(this.element.querySelector(".ourbusiness__overview__bg"))
        };

        this.arrows = [];
        this.images = [];
        this.imageLoadCount = 0;
        this.currentIndex = 0;
        this.prevIndex = null;

        // IDからカラム番号を抽出
        this.columnIndex = parseInt(selector.replace(/[^\d]/g, ''), 10) || 0;

        this.resize();
    };

    /**
     * リソースの読み込み
     */
    column.load = function () {
        // 矢印要素の取得
        const arrowNodes = this.ui.cases.element.querySelectorAll(".ourbusiness__overview__cases__item__arror");
        this.arrows = Array.from(arrowNodes).map(node => new GNS.DisplayObject(node));

        // 背景画像要素の取得
        const imgNodes = this.ui.bg.element.querySelectorAll(".ourbusiness__page__bg__img");

        if (imgNodes.length === 0) {
            this.dispatchEvent(new GNS.Event(GNS.Event.LOAD));
            return;
        }

        // 画像ごとの処理
        Array.from(imgNodes).forEach((node) => {
            const imgObj = new GNS.DisplayObject(node);
            this.images.push(imgObj);

            // 既にロード済みかチェック
            if (node.complete) {
                this.onImageLoaded();
            } else {
                // onLoad(successCallback, errorCallback)
                imgObj.onLoad(
                    () => this.onImageLoaded(),
                    () => this.onImageLoaded() // エラー時も進行させる
                );
            }
        });
    };

    /**
     * 画像単体のロード完了ハンドラ
     */
    column.onImageLoaded = function () {
        this.imageLoadCount++;

        // 全画像読み込み完了
        if (this.imageLoadCount >= this.images.length) {
            this.resize();
            this.dispatchEvent(new GNS.Event(GNS.Event.LOAD));
            this.startBackgroundAnimation();
        }
    };

    /**
     * リサイズ処理
     * 全画像のサイズ調整とコンテナの高さ設定を行う
     */
    column.resize = function () {
        this.images.forEach(img => {
            if (img) this._fitImage(img);
        });
        // コンテナの高さをwrapperに合わせる
        this.height = this.ui.wrapper.element.offsetHeight;
    };

    /**
     * 画像をコンテナに合わせて「Cover」サイズに調整する（旧関数 e）
     */
    column._fitImage = function (imgObj) {
        const containerW = this.element.offsetWidth;
        let containerH = this.ui.wrapper.element.offsetHeight;

        // SP/PCでの最小高さ制限
        if (GNS.isPC && containerH < 460) containerH = 460;
        else if (GNS.isSP && containerH < 600) containerH = 600;

        const imgW = imgObj.element.naturalWidth || imgObj.element.offsetWidth;
        const imgH = imgObj.element.naturalHeight || imgObj.element.offsetHeight;

        const imgRatio = imgW / imgH;

        let targetW = containerH * imgRatio;
        let targetH = containerH;

        // コンテナの幅の方が広い場合、幅に合わせて高さを拡大
        if (containerW > targetW) {
            targetH = (containerW / targetW) * targetH;
            targetW = containerW;
        }

        // 中央寄せ配置
        const posX = (containerW - targetW) >> 1; // Math.floor / 2 と同等
        const posY = (containerH - targetH) >> 1;

        // スタイル適用
        Object.assign(imgObj.element.style, {
            width: `${targetW}px`,
            height: `${targetH}px`,
            left: `${posX}px`,
            top: `${posY}px`
        });
    };

    column.reset = function () { };

    /**
     * 表示開始
     */
    column.show = function () {
        if (!this.isAnimating) {
            this.isAnimating = true;
            this.reset();
            // startBackgroundAnimationはload完了時に呼ばれているが、
            // 表示タイミングでの再開が必要な場合はここで呼ぶ制御を入れても良い
        }
    };

    /**
     * 非表示
     */
    column.hide = function () {
        this.stopBackgroundAnimation();
        this.isAnimating = false;
    };

    /**
     * クリックイベント
     */
    column._bind.click = function () {
        this.parent.scrollTo(this);
    };

    // ----------------------------------------------------------------
    // Animation Logic
    // ----------------------------------------------------------------

    /**
     * 背景スライドショーの開始（リセット含む）
     */
    column._bind.startBackgroundAnimation = function () {
        // 画像のリセット
        this.images.forEach(img => {
            img.removeClass("active");
            img.removeClass("next");
            TweenMax.killTweensOf(img.element);
            TweenMax.set(img.element, { alpha: 1, scale: 1 });
        });

        // 矢印のリセット
        this.arrows.forEach(arrow => {
            TweenMax.killTweensOf(arrow.element);
            TweenMax.set(arrow.element, { x: 0, alpha: 1 });
        });

        this.currentIndex = 0;
        this.prevIndex = null;

        this.updateBackgroundAnimation();
    };

    /**
     * スライドショーの更新（次の画像へ）
     */
    column._bind.updateBackgroundAnimation = function () {
        // 1. 前の画像の後始末
        if (this.prevIndex !== null) {
            const prevImg = this.images[this.prevIndex];
            const prevArrow = this.arrows[this.prevIndex];

            prevImg.removeClass("active");
            TweenMax.set(prevImg.element, { alpha: 1, scale: 1 });

            TweenMax.killTweensOf(prevArrow.element);
            TweenMax.set(prevArrow.element, { x: 0, alpha: 1 });
        }

        // 念のため現在以外の矢印アニメーションを停止
        this.arrows.forEach((arrow, i) => {
            if (i !== this.currentIndex) {
                TweenMax.killTweensOf(arrow.element);
                TweenMax.set(arrow.element, { x: 0, alpha: 1 });
            }
        });

        // 2. 現在の画像のアニメーション設定
        const currentImg = this.images[this.currentIndex];
        currentImg.removeClass("next");
        currentImg.addClass("active");

        TweenMax.set(currentImg.element, { alpha: 1, scale: 1 });

        // スケールアップのアニメーション（ゆっくり拡大）
        TweenMax.to(currentImg.element, ANIM.SCALE_DURATION, {
            delay: 0,
            scale: 1.1,
            alpha: 1,
            ease: Power0.easeNone
        });

        // フェードアウトまたは終了処理
        const onCompleteFunc = this.images.length > 1
            ? this.updateBackgroundAnimation // 次へ
            : () => TweenMax.killTweensOf(currentImg.element); // 1枚なら停止

        // 画像が複数ある場合はフェードアウトして次へループ
        if (this.images.length > 1) {
            TweenMax.to(currentImg.element, ANIM.FADE_OUT_DURATION, {
                delay: ANIM.FADE_OUT_DELAY,
                alpha: 0,
                ease: Cubic.easeOut,
                onComplete: onCompleteFunc // bind不要 (アロー関数または_bindによる解決)
            });
        } else {
            // 画像が1枚の場合はフェードアウトせずに待機だけさせる（必要なら実装）
            TweenMax.to(currentImg.element, ANIM.FADE_OUT_DURATION, {
                delay: ANIM.FADE_OUT_DELAY,
                // alpha: 0, // 1枚なら消さないのが一般的だが、元のロジックに従うならここ
                onComplete: onCompleteFunc
            });
        }

        // 3. 矢印のアニメーション開始
        const currentArrow = this.arrows[this.currentIndex];
        this.arrowBlink(currentArrow);

        // 4. インデックスの更新
        this.prevIndex = this.currentIndex;
        this.currentIndex++;
        if (this.currentIndex >= this.images.length) {
            this.currentIndex = 0;
        }

        // 次の画像にクラス付与（待機状態）
        this.images[this.currentIndex].addClass("next");
    };

    /**
     * アニメーションの完全停止
     */
    column._bind.stopBackgroundAnimation = function () {
        this.images.forEach(img => {
            img.removeClass("next");
            img.removeClass("active");
            TweenMax.killTweensOf(img.element);
            TweenMax.set(img.element, { alpha: 1, scale: 1 });
        });

        this.arrows.forEach(arrow => {
            TweenMax.killTweensOf(arrow.element);
            TweenMax.set(arrow.element, { x: 0, alpha: 1 });
        });
    };

    /**
     * 矢印の点滅アニメーション（ループ）
     */
    column.arrowBlink = function (arrow) {
        // 既存のTweenをキルして重複を防ぐ
        TweenMax.killTweensOf(arrow.element);

        // 右に動いて消える
        TweenMax.to(arrow.element, 0.6, {
            x: 10,
            autoAlpha: 0,
            delay: 0.6,
            ease: Cubic.easeOut,
            onComplete: () => {
                // 左に戻って（見えない状態で）
                TweenMax.to(arrow.element, 0, {
                    x: -12,
                    delay: 0.3,
                    ease: Linear.easeNone,
                    onComplete: () => {
                        // 元の位置に戻って現れる
                        TweenMax.to(arrow.element, 0.6, {
                            x: 0,
                            autoAlpha: 1,
                            delay: 0.2,
                            ease: Cubic.easeOut,
                            onComplete: () => {
                                // ループ継続（停止されていなければ）
                                // 停止ロジックは stopBackgroundAnimation で killTweensOf することで実現される
                                this.arrowBlink(arrow);
                            }
                        });
                    }
                });
            }
        });
    };

    return column._self;
}(GNS);
